import React from 'react';
import { Backdrop, Box, Button, Typography } from '@material-ui/core';
import { BrandColors } from '../../constants';
import { PromptBoxStyles } from '../styles/promptBox';

interface PromptBoxProps {
  title?: string;
  subtitle?: string;
  buttonText?: string;
  handleButtonClick?: () => void;
}

const PromptBox = (props: PromptBoxProps): JSX.Element => {
  const classes = PromptBoxStyles();

  return (
    <Backdrop open className={classes.rrBackdrop}>
      <Box
        zIndex="modal"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        position="fixed"
        width={1}
        color={BrandColors.white}
        bgcolor={BrandColors.blackWithOpacity9}
        className={classes.box}>
        <Box>
          <Typography color="inherit" variant="h1" align="center" className={classes.title}>
            {props.title}
          </Typography>
          <Typography color="inherit" variant="h3" align="center" className={classes.content}>
            {props.subtitle}
          </Typography>
        </Box>
        <Button onClick={props.handleButtonClick} className={classes.button}>
          {props.buttonText}
        </Button>
      </Box>
    </Backdrop>
  );
};

export default PromptBox;
